import React from "react";
import { Link } from "@inertiajs/react";

interface NavButtonProps {
    href?: string;
    scrollTo?: string;
    children: React.ReactNode;
}

const NavButton: React.FC<NavButtonProps> = ({
    href = "",
    scrollTo = "",
    children,
}) => {
    const handleClick = (event: React.MouseEvent<Element, MouseEvent>) => {
        if (scrollTo) {
            event.preventDefault();
            const section = document.getElementById(scrollTo);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }
    };

    return (
        <Link
            href={href || (scrollTo ? `#${scrollTo}` : "#")}
            onClick={(event) => handleClick(event)}
            className="inline-block w-full md:w-auto bg-primary-light text-white text-center py-2 px-[2vw] lg:px-6 text-[2.5vw]  md:text-sm xl:px-8 xl:text-[20px] font-semibold rounded-md hover:bg-hoverPrimary-light transition ease-in-out duration-300 dark:text-gray-300"
        >
            {children}
        </Link>
    );
};

export default NavButton;
